<template>
    <b-form-group :label="label"
                  :invalid-feedback="errorTxt"
                  :description="description"
                  :state="state">
        <b-form-textarea
                v-model="inputVal"
                :type="type"
                :state="state"
                :rows="row"
                max-rows="maxRows"
                :placeholder="placeholder"
                :readonly="readonly">
        </b-form-textarea>
    </b-form-group>
</template>

<script>
    export default {
        props: ['model', 'attribute', 'label', 'type', 'placeholder', 'errors', 'readonly', 'row', 'maxRows', 'errorOnly', 'description'],
        data() {
            return {inputVal: this.model[this.attribute] ? this.model[this.attribute] : null, state: null, errorTxt: ''}
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
    }
</script>